module.exports = require("./sw-KE.js");